export function isOneOf(exceptionList: (RegExp | string)[], errorMessage: string | undefined): boolean {
    return (typeof errorMessage == "string" &&
        exceptionList.some(exception => typeof exception === "string"
            ? errorMessage.toLowerCase().includes(exception.toLowerCase())
            : exception.test(errorMessage)));
}
